import { Modal } from "bootstrap";
import { nextTick } from "vue";

const hideModal = (
  modalEl: HTMLElement | null,
  callback?: () => void
): void => {
  nextTick(() => {
    if (!modalEl) {
      return;
    }

    const myModal = Modal.getInstance(modalEl);

    const handleClose = () => {
      modalEl.removeEventListener("hidden.bs.modal", handleClose);
      if (callback) {
        callback();
      }
    };

    modalEl.addEventListener("hidden.bs.modal", handleClose);

    if (myModal._isShown && !myModal._isTransitioning) {
      myModal.hide();
    } else {
      modalEl.addEventListener(
        "shown.bs.modal",
        () => {
          myModal.hide();
        },
        { once: true }
      );
    }
  });
};

const hideModalId = (modalId: string, callback?: () => void) => {
  nextTick(() => {
    if (!modalId) {
      return;
    }

    const modal = document.getElementById(modalId);

    if (!modal) {
      return;
    }

    const myModal = Modal.getInstance(modal);

    const handleClose = () => {
      modal.removeEventListener("hidden.bs.modal", handleClose);
      if (callback) {
        callback();
      }
    };

    modal.addEventListener("hidden.bs.modal", handleClose);

    if (myModal._isShown && !myModal._isTransitioning) {
      myModal.hide();
    } else {
      modal.addEventListener(
        "shown.bs.modal",
        () => {
          myModal.hide();
        },
        { once: true }
      );
    }
  });
};

const getOrCreateInstanceModal = (
  modalId: string,
  onShowCallback?: () => void,
  onHideCallback?: () => void
): void => {
  nextTick(() => {
    if (!modalId) {
      return;
    }

    const modal = document.getElementById(modalId);

    if (!modal) {
      return;
    }

    const handleShow = () => {
      modal.removeEventListener("shown.bs.modal", handleShow);
      if (onShowCallback) {
        onShowCallback();
      }
    };

    const handleClose = () => {
      modal.removeEventListener("hidden.bs.modal", handleClose);
      if (onHideCallback) {
        onHideCallback();
      }
    };

    modal.addEventListener("shown.bs.modal", handleShow);
    modal.addEventListener("hidden.bs.modal", handleClose);

    const myModal = Modal.getOrCreateInstance(modal);
    myModal.show();
  });
};

const showModal = (modalEl: HTMLElement | null): void => {
  if (!modalEl) {
    return;
  }

  const myModal = Modal.getInstance(modalEl);
  myModal.show();
};

const toggleModal = (modalEl: HTMLElement | null): void => {
  if (!modalEl) {
    return;
  }

  const myModal = Modal.getInstance(modalEl);
  myModal.toggle();
};

const removeModalBackdrop = (): void => {
  if (document.querySelectorAll(".modal-backdrop.fade.show").length) {
    document.querySelectorAll(".modal-backdrop.fade.show").forEach((item) => {
      item.remove();
    });
  }
};

export {
  removeModalBackdrop,
  hideModal,
  hideModalId,
  showModal,
  toggleModal,
  getOrCreateInstanceModal,
};
